import React, { useEffect, useState } from 'react'
import FormRender from '../../components/FormRender'
import useAxiosInstance from '../../hooks/useAxios'
import * as XLSX from 'xlsx';
import { CB_ENRICHMENT_PRESETS } from '../../helper';

const CBEnrichment = () => {
  const [formData, setFormData] = useState({
    'column_mapping': [],
    'mode': "email",
    'excel_file': null,
    'target_column': ''
  })
  const axiosInstance = useAxiosInstance()
  const [mapping, setMapping] = useState({});
  const [isSaving, setIsSaving] = useState(false)
  const extraInfoKeys = ['hq', 'url', 'logo', 'uuid', 'roles', 'domain', 'cb_rank', 'country', 'website', 'founders', 'org_name', 'sub_orgs', 'continent', 'num_exits', 'permalink', 'industries', 'ipo_status', 'legal_name', 'data_source', 'description', 'company_type', 'dt_createdOn', 'dt_updatedOn', 'primary_role', 'social_links', 'stock_symbol', 'year_founded', 'active_status', 'investor_type', 'num_employees', 'num_exits_ipo', 'num_investors', 'revenue_range', 'funding_rounds', 'investor_stage', 'list_investors', 'stock_exchange', 'list_executives', 'num_investments', 'old_ticker_name', 'list_investments', 'num_acquisitions', 'operating_status', 'funds_total_value', 'last_funding_date', 'list_acquisitions', 'short_description', 'last_funding_round', 'num_funding_rounds', 'last_funding_amount', 'location_identifier', 'amount_funding_total', 'funds_total_currency', 'funds_last_raised_date']
  
  const [selectedPreset, setSelectedPreset] = useState("")
  const [preset,setPreset] = useState(CB_ENRICHMENT_PRESETS)

  useEffect(()=>{
    console.log(mapping)
  },[mapping])
  
  return (
    <div>
      <div className="mr-4  p-3 my-5 border rounded-lg bg-white">
        <p className="text-2xl text-black font-medium mb-4">CB Enrichment</p>
        <FormRender
          formData={formData}
          formSettings={[{
            label: "Mode*",
            type: "select",
            saveKey: "mode",
            options: [
              { 'label': 'Email', value: 'email' },
              { 'label': 'Website', value: 'website' },
            ]
          }, {
            label: "Target Column*",
            type: "text",
            saveKey: "target_column",
            options: []
          }, {
            label: "Excel File*",
            type: "file",
            saveKey: "excel_file",
          }]}
          setFormData={setFormData}
        />
        <p className='text-sm font-semibold  mb-2 mt-4'>Presets available</p>
        <div className='grid grid-cols-3'>
        {preset.map(item=>{return <div key={item.label}>
          <button 
            onClick={()=>{
              if(selectedPreset===item.label){
                setSelectedPreset('')
                setMapping(JSON.parse(JSON.stringify({})))  
              }else{
                console.log(item.mapping)
                setMapping(JSON.parse(JSON.stringify(item.mapping)))
                setSelectedPreset(item.label)
              }
            }}
            className={`cursor-pointer ${selectedPreset===item.label ? 'border-black':'border-slate-300'} text-sm font-medium border px-3 py-2 rounded-lg`}>{item.label}</button>
        </div>})}
        </div>

        <p className='text-sm font-semibold  mb-2 mt-4'>Column Mapping</p>
        <div className="overflow-y-auto h-64 mt-2 bg-slate-100 p-1 rounded-lg w-full">
            <table className="w-full ">
              <thead className="border-b text-left">
                {/* <th className="px-2 py-1 text-gray-700 text-sm ">Select</th> */}
                <th className="px-2 py-1 text-gray-700 text-sm ">Key</th>
                <th className="px-2 py-1 text-gray-700 text-sm ">Label</th>
                <th className="px-2 py-1 text-gray-700 text-sm ">Blocked Keys (If any)</th>
              </thead>
              <tbody className="divide-y">
                {
                  extraInfoKeys?.map((key) => {
                    return (
                      <tr
                        className="cursor-pointer"
                        // onClick={()=>{}}
                        key={key}
                      >
                        {/* <td className="whitespace-nowrap  px-2 py-2 font-medium text-gray-900">
                          <input
                            type="checkbox"
                            readOnly
                            onClick={()=>{
                              setMapping(prev=>{
                                if (prev?.[key]){
                                  delete prev[key]
                                }else{
                                prev[key] = {
                                  'key':key,
                                  'label':''
                                }}
                                return prev
                              })
                            }}
                            checked={mapping?.key}
                          />
                        </td> */}
                        <td className="whitespace-nowrap  px-2 py-2 font-medium text-gray-900">
                          {key}
                        </td>
                        <td className="whitespace-nowrap  px-2 py-2 font-medium text-gray-900">
                          <input
                            value = {mapping?.[key]?.['label']}
                            onChange={(e)=>{
                              setMapping(prev=>{
                                let newPrev = JSON.parse(JSON.stringify(prev))
                                if (!newPrev?.[key]){
                                  newPrev[key] = {
                                    "key":key,
                                    "settings":{
                                      "blocked_keys":""
                                    }
                                  }
                                }  
                                newPrev[key]['label'] = e.target.value
                                return newPrev
                              })
                              
                            }}
                          />
                        </td>
                        <td className="whitespace-nowrap  px-2 py-2 font-medium text-gray-900">
                          <input
                            value = {mapping?.[key]?.['settings']?.['blocked_keys']}
                            onChange={(e)=>{
                              setMapping(prev=>{
                                let newPrev = JSON.parse(JSON.stringify(prev))
                                if (!newPrev?.[key]){
                                  newPrev[key] = {
                                    "key":key,
                                    "settings":{
                                      "blocked_keys":""
                                    }
                                  }
                                }  
                                newPrev[key]["settings"]['blocked_keys'] = e.target.value.split(",").map(it=>it.trim())
                                return newPrev
                              })
                              
                            }}
                          />
                        </td>
                      </tr>
                    );
                  })
                }
              </tbody>
            </table>
          </div>
          
        
        <button
          disabled={isSaving}
          className='bg-black px-3 mt-4 py-2 rounded text-sm font-sm disabled:bg-[#b6b6b6] disabled:text-black text-white'
          onClick={() => {
            setIsSaving(true)
            const _formData = new FormData();
            _formData.append('excel_file', formData.excel_file);
            _formData.append('target_column', formData.target_column);
            _formData.append('mode', formData.mode);
            _formData.append('column_mapping', JSON.stringify([
              { 'label': 'domain', 'key': 'domain' },
              ...Object.values(mapping).filter(it=>it.label!=='')
            ]))

            axiosInstance.post('/assets/cb_enrichment/', _formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            }).then(res => {
              const worksheet = XLSX.utils.json_to_sheet(res?.data?.results);
              const workbook = XLSX.utils.book_new();
              XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
              XLSX.writeFile(workbook, "CBEnrichedSandbox.xlsx");
              setIsSaving(false)
            }).catch(err => {
              console.log(err)
            })
          }
          }
        >{isSaving?'downloading....':'Download'}</button>
      </div>
    </div>
  )
}

export default CBEnrichment